export var MODAL_TYPES = {
  REGULAR: "regular",
  ILLUSTRATION: "withIllustration"
};